var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-content",style:({ zIndex: _vm.index })},[_c('select-color',{attrs:{"types":_vm.types,"info":_vm.info,"update-info":_vm.updateInfo},on:{"close":_vm.closePopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }